import axios, { AxiosResponse } from 'axios'
import { GOOGLE_MAPS_API_GET_GEOCODE } from 'constants/apiUrl'
import { IAddressToCoordsParams, IAddressToCoordsResponse } from 'typescript/interfaces/maps'

export const getCoordsFromAddress = (params: IAddressToCoordsParams) =>
  axios.get<IAddressToCoordsParams, AxiosResponse<IAddressToCoordsResponse>>(GOOGLE_MAPS_API_GET_GEOCODE, {
    params: { key: process.env.REACT_APP_GMAPS_API_KEY, ...params },
  })
